module.exports = __webpack_public_path__ + "static/media/step3.218285ef.svg";